export const PERSON_CHANGED = 'PERSON_CHANGED'
export const API_FAILED = 'API_FAILED'



// WEBPACK FOOTER //
// ./src/vuex/mutation_types.js